import { render, staticRenderFns } from "./ServiceRepairList.vue?vue&type=template&id=23a6eba3&scoped=true"
import script from "./ServiceRepairList.vue?vue&type=script&lang=js"
export * from "./ServiceRepairList.vue?vue&type=script&lang=js"
import style0 from "./ServiceRepairList.vue?vue&type=style&index=0&id=23a6eba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6eba3",
  null
  
)

export default component.exports